import { datadogLogs, LogsInitConfiguration } from '@datadog/browser-logs';

export const initDatadogLogs = (): void => {
    const env = process.env.NEXT_PUBLIC_ENV || 'local';
    if (env === 'local') {
        return;
    }
    datadogLogs.init({
        clientToken: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN!,
        site: process.env
            .NEXT_PUBLIC_DATADOG_SITE as LogsInitConfiguration['site'],
        service: process.env.NEXT_PUBLIC_DATADOG_SERVICE,
        version: process.env.BUILD_ID,
        env: env,
        sessionSampleRate: 100,
        silentMultipleInit: true,
        forwardConsoleLogs: [],
        forwardErrorsToLogs: true,
    });
};
